/** How an Oracle turn ended. Only `Success` is a finished answer; nothing else may count as progress. */
export enum OracleTurnEnding {
  Success = 'success',
  Interrupted = 'interrupted',
  Paused = 'paused',
  Unavailable = 'unavailable',
}

/** The SSE events that end a turn. The legacy `end` / `error` events still follow them on the wire. */
export enum OracleEndingEvent {
  Success = 'success',
  Interrupted = 'interrupted',
  /** `{ status: 'paused' | 'unavailable' }`: the safety gate withheld the answer, so no text was sent. */
  SafetyStatus = 'safety_status',
}

/** The `status` a `safety_status` event carries. */
export enum OracleSafetyStatus {
  Paused = 'paused',
  Unavailable = 'unavailable',
}
